"use client";

import { ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function QualityAndSafetyStandards() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="quality-and-safety-standards" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div ref={ref} className={`bg-secondary rounded-2xl p-8 md:p-16 max-w-4xl mx-auto text-center shadow-sm border border-border/50 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-xl bg-primary/10 mb-6">
            <ShieldCheck className="w-8 h-8 text-primary" />
          </div>
          
          <h2 className="text-3xl md:text-4xl font-default font-bold text-foreground mb-6">Fackmässigt utförande i Karlstad enligt gällande branschnormer</h2>
          
          <p className="text-lg text-muted-foreground mb-10 leading-relaxed max-w-3xl mx-auto">Vid en badrumsrenovering är det lika viktigt att de bakomliggande konstruktionerna blir rätt utförda som de synliga ytskikten. Vi bygger hållbara badrum i Karlstad med fokus på genomtänkta konstruktioner och säkra infästningar, bland annat med 15 mm plywood där konstruktionen kräver det. Befintliga golvbrunnar bedöms och byts när det krävs enligt gällande branschregler. VVS-installationerna utförs av vårt moderbolag RSAB Rörservice AB enligt Säker Vattens branschregler. För tätskikt och plattsättning samarbetar vi med behöriga företag inom <Link to="https://www.bkr.se/" newTab className="text-blue-600 underline hover:text-blue-800 transition-colors cursor-pointer">BKR</Link> eller <Link className="text-blue-600 underline hover:text-blue-800 transition-colors cursor-pointer" href="https://www.gvk.se/" newTab>GVK</Link> beroende på projektets lösning.</p>
          
          <Button asChild size="lg" className="px-8">
            <Link to="/ContactUs">Kontakta oss</Link>
          </Button>
        </div>
      </div>
    </section>;
}